import { TutorialStep } from 'src/replicant/tutorial/tutorial.ruleset';
import { TutorialEvent } from '../TutorialController';
import OrdinaryTutorial from './OrdinaryTutorial';
import { showTutorial } from '../tutorial.util';

export class SlotsTutorial extends OrdinaryTutorial {
  public readonly step: TutorialStep = 'slots';

  public async handleEvent(event: TutorialEvent): Promise<boolean> {
    if (event !== 'slotsUnlocked') {
      return false;
    }

    // Show tutorial popup and grant rewards
    await showTutorial('slots', {
      $stepIndex: 33,
      $stepName: 'slots',
    });

    return true;
  }
}
